// Parameter builders shared by more than one call site, so each site stays one line.

import type { DvMapState } from '../sim/dvMap.ts';
import { devFlag, urlFlag, TEST_SWITCHES } from '../urlFlags.ts';
import type { EventParams } from './events.ts';

/** `?analyticswrongtarget=1`: a trip reported with its origin as the target, `analytics-check.mjs --inject wrong-target`. */
const wrongTarget = devFlag(() => TEST_SWITCHES && urlFlag('analyticswrongtarget'));

/** A figure to `places` decimals: what every trip event rounds its own to. */
export function roundTo(v: number, places: number): number {
  const k = 10 ** places;
  return Math.round(v * k) / k;
}

/** The picked row of the delta-v map as a `trip_planned`, or null with nothing picked. */
export function tripPlanned(s: DvMapState, source: 'list' | 'name'): EventParams['trip_planned'] | null {
  const plan = s.selected;
  if (plan === null) return null;
  const origin = s.survey?.originBodyId ?? 'none';
  return {
    origin_id: origin,
    target_id: wrongTarget() ? origin : plan.destinationId,
    dv_kms: roundTo(plan.totalDvKmS, 3),
    tof_days: roundTo(plan.timeOfFlightDays, 1),
    wait_days: roundTo(plan.windowWaitDays, 1),
    source,
  };
}
